import Paper from '@mui/material/Paper';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAppContext } from 'Context/AppContext';
import { PATH_INFO } from '../router';
import { getSidebarTitleByPath } from './utils';

import styles from './layout.module.css';

export interface ContentPropType {
  children?: React.ReactElement;
  navKey?: string;
  subNavKey?: string;
  subSubNavKey?: string;
}

interface PathInfoInterface {
  title: string;
  tabList?: string[];
}

export default function Content(props: ContentPropType) {
  const { children, navKey, subNavKey, subSubNavKey } = props;
  const location = useLocation();
  const { tabNumber, setTabNumber } = useAppContext();
  const [pathInfo, setPathInfo] = useState<PathInfoInterface>();

  useEffect(() => {
    const matchedPath = Object.keys(PATH_INFO)
      .filter((key) => location.pathname === key || location.pathname.startsWith(key + '/'))
      .sort((a, b) => b.length - a.length)[0] as keyof typeof PATH_INFO | undefined;

    const info = matchedPath ? PATH_INFO[matchedPath] : undefined;
    setPathInfo(info);
  }, [location.pathname]);

  return (
    <Paper
      sx={{
        margin: 'auto',
        borderRadius: 0,
        overflow: 'hidden',
        backgroundColor: 'inherit',
        boxShadow: 'none',
        width: '100%',
        maxWidth: '100%',
      }}
    >
      <NavigationTree navKey={navKey} subNavKey={subNavKey} subSubNavKey={subSubNavKey} />
      {pathInfo?.tabList && pathInfo.tabList.length > 0 && (
        <Box sx={{ bgcolor: '#ffffff', borderBottom: '1px solid #e0e0e0', px: 2, mb: 2 }}>
          <Tabs
            value={tabNumber}
            textColor='primary'
            indicatorColor='primary'
            onChange={(e, value) => {
              setTabNumber?.(value);
            }}
            sx={{ minHeight: 40 }}
          >
            {pathInfo.tabList.map((e, index) => (
              <Tab value={index} label={e} key={index} sx={{ fontSize: '13px', fontWeight: 500 }} />
            ))}
          </Tabs>
        </Box>
      )}
      <div style={{ padding: '0px 8px', width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>{children}</div>
    </Paper>
  );
}

interface NavigationTreeProps {
  navKey?: string;
  subNavKey?: string;
  subSubNavKey?: string;
}

const navList = {
  ac: { name: 'Thêm tài khoản', path: '/add-account' },
  cl: { name: 'Danh sách tài khoản', path: '/account-list' },
  ab: { name: 'Thêm biên lai', path: '/add-bill' },
  bl: { name: 'Danh sách biên lai', path: '/bill-list' },
  pbl: { name: 'Danh sách chờ duyệt', path: '/pending-approval-bill-list' },
  qps: { name: 'Gộp & Xuất QR học phí', path: '/qr-payment-slip' },
  pf: { name: 'Thông tin cá nhân', path: '/profile' },
  acl: { name: 'Thêm lớp học', path: '/add-class' },
  cll: { name: 'Danh sách lớp học', path: '/class-list' },
  ist: { name: 'Nhập danh sách học sinh', path: 'import-student-list' },
  stl: { name: 'Danh sách học sinh', path: '/student-list' },
  ap: { name: 'Thêm phụ huynh', path: '/add-parent' },
  pl: { name: 'Danh sách phụ huynh', path: '/parent-list' },
  acy: { name: 'Thêm lớp năm học', path: '/add-class-year' },
  cyl: { name: 'Danh sách lớp học theo năm', path: '/class-year-list' },
  clyi: { name: 'Danh sách nguồn thu theo lớp', path: '/class-year-income' },

  hc: { name: 'Danh sách lớp chủ nhiệm', path: '/homeroom-classes' },
  hcd: { name: 'Chi tiết lớp chủ nhiệm', path: '/homeroom-class-detail' },
  scl: { name: 'Danh sách lớp dạy', path: '/subject-class-list' },
  scd: { name: 'Chi tiết lớp dạy', path: '/subject-class-detail' },
  bli: { name: 'Chi tiết biên lai', path: '/bill-list/bill-info' },

  rs: { name: 'Cấu hình nguồn thu', path: '/revenue-sources' },
  rb: { name: 'Cấu hình khối thu', path: '/revenue-blocks' },
  wm: { name: 'Cấu hình tháng làm việc', path: '/work-month' },
  qr: { name: 'Đăng ký nhanh', path: '/quick-register' },
  rsd: { name: 'Cấu hình nguồn thu', path: '/revenue-source' },
  ic: { name: 'Cấu hình hóa đơn', path: '/invoice-config' },
  ih: { name: 'Lịch sử hóa đơn', path: '/invoice-history' },
  cma: { name: 'Chấm ngày', path: '/class-month-attendance' },
  cas: { name: 'Chốt thực tế', path: '/class-actual-settle' },
  cscf: { name: 'Kết chuyển số dư', path: '/class-settle-carry-forward' },
  cps: { name: 'Theo dõi thu nộp', path: '/class-payment-statistics' },
  rpt: { name: 'Trung tâm Báo cáo', path: '/reports' },
};

const subNavList = {
  ci: { name: 'Chi tiết tài khoản', path: '/account-list/account-info' },
  bi: { name: 'Chi tiết biên lai', path: '/bill-list/bill-info' },
  cli: { name: 'Chi tiết lớp học', path: '/class-list/class-info' },
  sti: { name: 'Chi tiết học sinh', path: '/student-list/student-info' },
  ast: { name: 'Thêm học sinh', path: '/add-student' },
  ii: { name: 'Chi tiết nguồn thu theo lớp', path: '/detail-class-year-income' },
};
const subSubNavList = {
  sfi: { name: 'Chi tiết nguồn thu học sinh', path: '/revenue-source' },
};


const NavigationTree: React.FC<NavigationTreeProps> = ({
  navKey,
  subNavKey,
  subSubNavKey,
}) => {
  const navEntry = navKey ? navList[navKey as keyof typeof navList] : undefined;
  const navDisplayName =
    (navEntry?.path ? getSidebarTitleByPath(navEntry.path) : undefined) || navEntry?.name;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ margin: '16px 24px', fontSize: '14px' }}
    >
      <Link
        className={`${styles.link} ${navKey ? styles.previous_nav : styles.current_nav}`}
        to='/'
        style={{ textDecoration: 'none' }}
      >
        Trang chủ
      </Link>
      
      {navKey && (
        <Link
          className={`${styles.link} ${subNavKey ? styles.previous_nav : styles.current_nav}`}
          to={navEntry?.path || '#'}
          style={{ textDecoration: 'none' }}
        >
          {navDisplayName}
        </Link>
      )}

      {subNavKey && (
        subSubNavKey ? (
          <Link
            className={`${styles.link} ${styles.previous_nav}`}
            to={subNavList[subNavKey as keyof typeof subNavList]?.path || '#'}
            onClick={(e) => {
              e.preventDefault();
              window.history.back();
            }}
            style={{ textDecoration: 'none' }}
          >
            {subNavList[subNavKey as keyof typeof subNavList]?.name}
          </Link>
        ) : (
          <Typography sx={{ color: '#000000', fontSize: '14px', fontWeight: 600 }}>
            {subNavList[subNavKey as keyof typeof subNavList]?.name}
          </Typography>
        )
      )}

      {subSubNavKey && (
        <Typography sx={{ color: '#000000', fontSize: '14px', fontWeight: 600 }}>
          {subSubNavList[subSubNavKey as keyof typeof subSubNavList]?.name}
        </Typography>
      )}
    </Breadcrumbs>
  );
};
